import { render, staticRenderFns } from "./AllSkillsTab.vue?vue&type=template&id=2e0da766&scoped=true&"
import script from "./AllSkillsTab.vue?vue&type=script&lang=js&"
export * from "./AllSkillsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0da766",
  null
  
)

export default component.exports